// Injects the custom fonts referenced by monogram_text entries so the live line
// preview can render in them, returning a generated font-family name per font
// URL (each injected only once).

const families = new Map();
let counter = 0;

function fontFormat(url) {
  const path = url.split("?")[0].toLowerCase();
  if (path.endsWith(".woff2")) return "woff2";
  if (path.endsWith(".woff")) return "woff";
  if (path.endsWith(".ttf")) return "truetype";
  if (path.endsWith(".otf")) return "opentype";
  return null;
}

/**
 * Ensure the font at `url` is injected and return the font-family name to apply
 * to a preview line. Returns null when no URL is given.
 *
 * @param {string|undefined} url hosted font file URL
 * @returns {string|null}
 */
export function monogramFontFamily(url) {
  if (!url) return null;
  if (families.has(url)) return families.get(url);

  const family = `monogram-font-${++counter}`;
  const format = fontFormat(url);
  const src = format
    ? `url("${url}") format("${format}")`
    : `url("${url}")`;

  const style = document.createElement("style");
  style.textContent = `@font-face{font-family:"${family}";src:${src};font-display:swap;}`;
  document.head.appendChild(style);

  families.set(url, family);
  return family;
}
